<template>
  <div class="container">
    <div class="wrapper">
      <div class="dialog">
        <div class="title">{{ title }}</div>
        <ul :class="rtl && 'rtl'">
          <li v-for="(opt, key) in options" :key="key" class="ion-activatable" @click="onClick(key)" :class="selectedValue.includes(key) && 'active'">
            <span style="color: #222">{{ opt.description }}</span>
            <ion-icon :icon="checkbox" v-if="selectedValue.includes(key)" :size="iconSize" color="primary"></ion-icon>
            <ion-icon :icon="squareOutline" v-if="!selectedValue.includes(key)" :size="iconSize" color="medium"></ion-icon>
            <ion-ripple-effect></ion-ripple-effect>
          </li>
        </ul>
        <div v-if="!quick">
          <ion-button fill="clear" expand="full" @click="updateValue">Xác nhận</ion-button>
        </div>
      </div>
    </div>
    <div class="bottom-pad"></div>
  </div>
</template>

<style lang="scss" scoped>
:root {
  --bottom-padding: 10vh;
}
.container {
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .wrapper {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    .dialog {
      min-width: 80vw;
      margin: 0;
      padding: 0;
      background-color: #fff;
      border-radius: 10px;
      .title {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        background-color: #f66;
        color: #fff;
        text-align: center;
        padding: 1vh;
      }
      ul {
        margin: 1vh 2vw;
        padding: 0;
        &.rtl {
          li {
            flex-direction: row-reverse;
          }
        }
        li {
          overflow: hidden;
          list-style-type: none;
          padding: 1vh 2vw;
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: 1px solid #fff;
          &.active {
            background-color: #ffc;
            border-radius: 8px;
          }
        }
      }
    }
  }
  .bottom-pad {
    height: var(--bottom-padding);
  }
}
</style>

<script>
  import {
    IonButton,
    IonIcon,
    IonRippleEffect,
    modalController,
  } from '@ionic/vue';
  import {
    closeCircle,
    checkbox,
    squareOutline,
  } from 'ionicons/icons'
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'StageSelectorModal',
    components: {
      IonRippleEffect,
      IonIcon,
      IonButton
    },
    props: {
      title: String,
      options: Object,
      value: Array,
      rtl: Boolean,
      iconSize: String,
      quick: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selectedValue: []
      }
    },
    mounted() {
      this.selectedValue = this.value;
    },
    methods: {
      cancel() {
        modalController.dismiss({
          cancel: true
        });
      },
      onClick(key) {
        if (this.selectedValue.includes(key)) {
          if (this.selectedValue.length > 1) {
            this.selectedValue.splice(this.selectedValue.indexOf(key), 1);
          }
        } else {
          this.selectedValue.push(key);
        }
        if (this.quick) {
          this.updateValue();
        }
      },
      updateValue() {
        if (this.selectedValue.includes(this.value)) {
          this.cancel();
          return
        }

        modalController.dismiss({
          cancel: false,
          value: this.selectedValue
        });
      },
    },
    setup() {
      return {
        closeCircle,
        checkbox,
        squareOutline,
      }
    }
  })
</script>
